/**********************
 *
 */

import React, { useState } from "react";
import { sendGET, sendPOST, sendDELETE } from "../utils/comm.js";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
//import ReactTooltip from "react-tooltip";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledLabel = styled.div`
  width: 10em;
  display: inline-block;
  margin-right: 1em;
  text-align: right;
`;

function makePromoRecord() {
  let record = {
    dateValue: null,
    name: "",
    validDays: "",
    useLimitCount: "",
    percentOff: 0,
    timesUsed: null,
    comment: "",
    isPromoStillValid: null,
    providerEmail: "",
  };
  record.dateValue = new Date().getTime();
  return record;
}

const AddRow = ({
  promoRecord,
  shouldHighlight, // Basically, is this the title-row
  shouldColor,
  callback,
}) => {
  console.log("addRow: promoRecord:", promoRecord);
  let style = {
    display: "table-cell",
    paddingRight: "16px",
    marginRight: "10px",
    width: "25px",
    fontFamily: "courier",
  };
  return (
    <div
      style={{
        display: "table-row",
        whiteSpace: "nowrap",
        lineHeight: "1.7em",
        fontWeight: shouldHighlight ? "bold" : "normal",
        backgroundColor: shouldColor ? "#e0f4e9" : "normal",
        fontSize: "1.6em",
      }}
    >
      {shouldHighlight ? (
        <div>&nbsp;&nbsp;</div>
      ) : (
        <div
          onClick={() => {
            callback("delete");
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
          &nbsp;
        </div>
      )}

      {shouldHighlight
        ? Object.keys(promoRecord).map(
            (key) =>
              key !== "isPromoStillValid" && (
                <div key={key} style={style}>
                  {key}
                </div>
              )
          )
        : Object.keys(promoRecord).map((key) => {
            let useStyle = { ...style };
            let val = promoRecord[key];
            if (key === "dateValue") val = new Date(val).toLocaleString();
            if (key === "percentOff") {
              //val = (val / 100).toFixed(2);
              val += "%";
              useStyle = { ...useStyle, textAlign: "right" };
            }
            if (!promoRecord.isPromoStillValid)
              useStyle = { ...useStyle, textDecoration: "line-through" };
            return (
              <div key={key} style={useStyle}>
                {val}
              </div>
            );
          })}
    </div>
  );
};

export default (props) => {
  let [rows, setRows] = useState(null);
  const [code, setCode] = useState("");
  const [showAddPanel, setShowAddPanel] = useState(false);
  const [newPromoRecord, setNewPromoRecord] = useState(makePromoRecord());

  const fetchPromos = async () => {
    let promoRecord = makePromoRecord();

    let str = "/promos/" + code;
    let results;
    try {
      results = await sendGET(str);
    } catch (e) {
      console.log("FAILED, e:", e);
      console.log("e.name:", e.name);
      console.log("e.msg:", e.message, JSON.stringify(e.message));
      debugger;
      return;
    }
    results = results.promos;
    console.log("results:", results);
    rows = [];
    rows.push(
      <AddRow
        key={rows.length}
        promoRecord={promoRecord}
        shouldHighlight={true}
        shouldColor={false}
        callback={(e) => {}}
      />
    );
    for (let i = 0; i < results.length; i++) {
      console.log("Adding row:", results[i]);
      promoRecord = new makePromoRecord();
      for (let key in promoRecord) promoRecord[key] = results[i][key];
      rows.push(
        <AddRow
          promoRecord={promoRecord}
          key={1000 + i}
          shouldHighlight={false}
          shouldColor={i % 2 === 0}
          callback={async (cmd) => {
            if (cmd === "delete") {
              console.log("Deleting....");
              debugger;
              if (results[i].isPromoStillValid) {
                if (
                  !window.confirm(
                    "You should not delete codes that are in-use. Still want to delete?"
                  )
                )
                  return;
              }
              await sendDELETE("/promos/" + code, results[i]);
              fetchPromos();
            }
          }}
        />
      );
    }
    setRows(
      <div
        style={{
          display: "table",
          fontSize: "0.5em",
          marginTop: "10px",
        }}
      >
        {rows}
      </div>
    );
  };

  return (
    <div
      style={{
        color: "black",
        backgroundColor: "rgb(244,245,250)",
        borderRadius: "30px",
        margin: "auto auto",
        marginTop: "10px",
        padding: "1em",
        width: "90%",
        fontSize: "1em",
      }}
    >
      <h2>System Promo Codes</h2>
      <StyledLabel>System ID:&nbsp;</StyledLabel>
      <input
        type="text"
        value={code}
        onChange={(e) => {
          e.preventDefault();
          setCode(e.target.value);
        }}
      />
      &nbsp;
      <button
        onClick={async (e) => {
          e.preventDefault();
          e.stopPropagation();
          fetchPromos();
        }}
      >
        {" "}
        GO
      </button>
      {rows}
      {rows && (
        <button
          onClick={(e) => {
            let temp = makePromoRecord();
            setNewPromoRecord(temp);
            setShowAddPanel(true);
          }}
        >
          New...
        </button>
      )}
      <Dialog
        open={showAddPanel}
        TransitionComponent={Transition}
        keepMountedNO
        onClose={() => setShowAddPanel(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Create new Promo code entry"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description"></DialogContentText>
          <StyledLabel>Name&nbsp;</StyledLabel>
          <input
            autofocus
            type="text"
            value={newPromoRecord.name}
            onChange={(e) => {
              e.preventDefault();
              console.log("changed value:", e.target.value);
              newPromoRecord.name = e.target.value;
              debugger;
              setNewPromoRecord({ ...newPromoRecord });
            }}
          />
          <br />
          <StyledLabel>Valid days&nbsp;</StyledLabel>
          <input
            type="number"
            value={newPromoRecord?.validDays}
            onChange={(e) => {
              e.preventDefault();
              newPromoRecord.validDays = parseInt(e.target.value);
              setNewPromoRecord({ ...newPromoRecord });
            }}
          />
          <br />
          <StyledLabel>Use Limit Count&nbsp;</StyledLabel>
          <input
            type="number"
            value={newPromoRecord?.useLimitCount}
            onChange={(e) => {
              e.preventDefault();
              newPromoRecord.useLimitCount = parseInt(e.target.value);
              setNewPromoRecord({ ...newPromoRecord });
            }}
          />
          <br />
          <StyledLabel>Percent Off&nbsp;</StyledLabel>
          <input
            type="number"
            value={newPromoRecord?.percentOff}
            onChange={(e) => {
              e.preventDefault();
              newPromoRecord.percentOff = parseInt(e.target.value);
              setNewPromoRecord({ ...newPromoRecord });
            }}
          />
          {"%"}
          <StyledLabel>Comment&nbsp;</StyledLabel>
          <input
            type="text"
            value={newPromoRecord?.comment}
            onChange={(e) => {
              e.preventDefault();
              newPromoRecord.comment = e.target.value;
              setNewPromoRecord({ ...newPromoRecord });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={async (e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log("Add called...", newPromoRecord);
              // Clean it up...
              let keys = Object.keys(newPromoRecord);
              for (let k in keys) {
                debugger;
                let key = keys[k];
                if (
                  newPromoRecord[key] == null ||
                  (newPromoRecord[key] === "" && newPromoRecord[key] !== 0)
                ) {
                  /* ||   isNaN(newPromoRecord[key] ) */
                  delete newPromoRecord[key];
                }
              }
              // TELL THE SERVER!
              console.log("New:", newPromoRecord);
              debugger;
              try {
                let result = await sendPOST("/promos/" + code, newPromoRecord);
                //console.log("Result:", result);
              } catch (e) {
                console.log("Error:", e);
                if (e.json?.err?.code === 11000)
                  alert("Duplicates are not allowed");
                else
                  alert(
                    "Failed to save, status:" +
                      e.status +
                      "json:" +
                      JSON.stringify(e.json)
                  );
                //debugger;
                return e;
              }
              await fetchPromos();
              setShowAddPanel(false);
            }}
            color="primary"
          >
            Add
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log("Cancel called...");
              setShowAddPanel(false);
            }}
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
